import http from '@/http';
import i18n from '@/i18n';
import pluralize from 'pluralize';
import { notification } from 'ant-design-vue';

const types = {
    CRUD_SET_RESOURCE: 'CRUD_SET_RESOURCE',
    CRUD_SET_RESOURCES: 'CRUD_SET_RESOURCES',
    CRUD_ADD_RESOURCE: 'CRUD_ADD_RESOURCE',
    CRUD_MUTATE_RESOURCE: 'CRUD_MUTATE_RESOURCE',
    CRUD_REMOVE_RESOURCE: 'CRUD_REMOVE_RESOURCE',
};


// state
export default (resourceName) => {
    const singularResourceName = pluralize.singular(resourceName);

    return ({
        types,
        state: {
            [resourceName]: [],
            [singularResourceName]: {},
        },
        mutations: {
            [types.CRUD_SET_RESOURCE](state, resource) {
                state[singularResourceName] = resource;
            },
            [types.CRUD_SET_RESOURCES](state, resources) {
                state[resourceName] = resources;
            },
            [types.CRUD_ADD_RESOURCE](state, resource) {
                state[resourceName].push(resource);
            },
            [types.CRUD_REMOVE_RESOURCE](state, resource) {
                state[resourceName] = state[resourceName].filter(stateResource => {
                    return stateResource.id !== resource.id;
                });
            },
            [types.CRUD_MUTATE_RESOURCE](state, resource) {
                state[resourceName] = state[resourceName].map(stateResource => {
                    if (stateResource.id === resource.id) {
                        return resource;
                    }
                    return stateResource;
                });
            },
        },
        actions: {
            remove({ commit }, resource) {
                commit(types.CRUD_REMOVE_RESOURCE, resource);
            },
            mutate({ commit }, resource) {
                commit(types.CRUD_MUTATE_RESOURCE, resource);
            },
            add({ commit }, resource) {
                commit(types.CRUD_ADD_RESOURCE, resource);
            },
            fetch({ commit }, id) {
                if (!id) {
                    return http.get(resourceName)
                        .then(response => {
                            commit(types.CRUD_SET_RESOURCES, response);
                            return response;
                        });
                }
                return http.get(`${resourceName}/${id}`)
                    .then(response => {
                        commit(types.CRUD_SET_RESOURCE, response);
                        return response;
                    });
            },
            save({ commit }, resource) {
                return http.post(resourceName, resource)
                    .then(response => {
                        commit(types.CRUD_SET_RESOURCE, response);
                        notification.success({
                            message: i18n.t('entitySaved', {
                                entity: i18n.t(singularResourceName),
                            }),
                        });
                        return response;
                    });
            },
            update({ commit }, { id, resource }) {
                return http.patch(`${resourceName}/${id}`, resource)
                    .then(response => {
                        commit(types.CRUD_SET_RESOURCE, response);
                        notification.success({
                            message: i18n.t('entitySaved', {
                                entity: i18n.t(singularResourceName),
                            }),
                        });
                        return response;
                    });
            },
            delete(context, id) {
                return http.delete(`${resourceName}/${id}`)
                    .then((response) => {
                        notification.success({
                            message: i18n.t('entityDeleted', {
                                entity: i18n.t(singularResourceName),
                            }),
                        });
                        return response;
                    })
                    .catch(errors => {
                        if (errors.response.status === 422) {
                            notification.warning({
                                message: errors.response.data.errors.id[0],
                            });
                        }
                        return errors;
                    });
            },
        },
    });
};
